import {
  CONFIRMED_GET_DEPARTMENTS,
  CONFIRMED_CREATE_DEPARTMENT_ACTION,
  CONFIRMED_DELETE_DEPARTMENT_ACTION,
  CONFIRMED_EDIT_DEPARTMENT_ACTION,
} from "../actions/DepartmentType";

const initialState = {
  departments: [],
  loading: false,
  error: null,
  num_rows: 0
};

export default function DepartmentReducer(state = initialState, action) {
  switch (action.type) {
    case CONFIRMED_GET_DEPARTMENTS:
      return {
        ...state,
        // departments: action.payload,
        departments: action.payload.departments,
        num_rows: action.payload.num_rows,
        loading: false,
        error: null
      };

    case CONFIRMED_CREATE_DEPARTMENT_ACTION:
      return {
        ...state,
        departments: [...state.departments, action.payload],
      };

    case CONFIRMED_DELETE_DEPARTMENT_ACTION:
      return {
        ...state,
        departments: state.departments.filter(
          department => department.department_id !== action.payload.department_id
        ),
      };

    case CONFIRMED_EDIT_DEPARTMENT_ACTION:
      return {
        ...state,
        departments: state.departments.map(department =>
          department.department_id === action.payload.department_id 
            ? action.payload 
            : department
        ),
      };

    default:
      return state;
  }
}